module.exports = __webpack_public_path__ + "img/ico-ios.9ec1cfbf.png";